/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createSessionStorageProvider } from '@jira/platform__browser-storage-providers/src/controllers/session-storage/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { ArticleId, State, HistoryItem } from '../model/types.tsx';

const iphStorage = createSessionStorageProvider('iph');

export const setNavigationData =
	(navigationData: { articleId?: ArticleId; history?: HistoryItem[] }): Action<State> =>
	({ setState, getState }) => {
		const currentState = getState();
		setState({
			navigationData: {
				articleId: navigationData.articleId
					? navigationData.articleId
					: currentState.navigationData.articleId,
				history: navigationData.history
					? navigationData.history
					: currentState.navigationData.history,
			},
		});

		// @browser-storage setter
		iphStorage.set('history', []);
	};

export const setReleaseNotesNotifications =
	(releaseNotesNotifications: number): Action<State> =>
	({ setState }) => {
		setState({
			releaseNotesNotifications,
		});
	};
